import { getWidgetPresets } from "@/lib/agent/widgetPresets";
import type { AgentMessage, AgentWidget } from "@/types/createAgent";

/** Matches the widget filtering used by AgentMessage. */
export function isPresentableChatWidget(widget: AgentWidget): boolean {
  return widget.active !== false || getWidgetPresets(widget).length === 0;
}

/**
 * Mirrors the content surfaces AgentMessage can actually put on screen.
 * `hidden: false` alone is not enough: interrupted streams can leave a blank
 * placeholder whose only output would otherwise be a timestamp.
 */
export function isRenderableChatMessage(message: AgentMessage): boolean {
  if (message.hidden) return false;

  const hasPresentableWidget = Boolean(
    message.role === "assistant" &&
    message.widgets?.some(isPresentableChatWidget)
  );
  const hasAssistantSurface = Boolean(
    message.role === "assistant" &&
    (message.sources?.length || message.presets?.length || hasPresentableWidget)
  );

  return Boolean(
    message.content?.trim() ||
    message.imageUrl ||
    message.imageUrls?.length ||
    hasAssistantSurface
  );
}

export function hasRenderableChatTranscript(messages: AgentMessage[]): boolean {
  return messages.some(isRenderableChatMessage);
}
